<template>
  <div>
    <div class="container">
      <div class="kuang">
        <div class="tit">
          <img src="@/assets/layout/titlelogo.png" alt="" />
          <div class="txt">
            <p>社科申报平台</p>
          </div>
        </div>

        <div class="tabs">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="补全信息" force-render>
              <div style="padding-top: 15px">
                <a-input
                  v-model="dataInfo.userName"
                  placeholder="请输入单位名称"
                >
                </a-input>
                <div class="interval"></div>
                <a-input v-model="dataInfo.position" placeholder="职务">
                </a-input>
                <div class="interval"></div>
                <a-input v-model="dataInfo.phone" placeholder="请输入联系电话">
                </a-input>
                <div class="interval"></div>
                <a-input v-model="dataInfo.email" placeholder="邮箱"> </a-input>
                <div class="interval"></div>
                <a-input v-model="dataInfo.bankAddress" placeholder="开户行">
                </a-input>
                <div class="interval"></div>
                <a-input v-model="dataInfo.bankName" placeholder="户名">
                </a-input>
                <div class="interval"></div>
                <a-input v-model="dataInfo.bankAccount" placeholder="银行账户">
                </a-input>
                <div class="interval"></div>
                <button class="loginbtn" @click="register">确认</button>
                <div class="interval"></div>
                <!-- <div class="choose">
                  <p style="color: #007651" @click="registerClick(1)">
                    注册账户
                  </p>
                  <span>|</span>
                  <p style="color: #007651" @click="registerClick(0)">去登陆</p>
                </div> -->
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  decUserRegisterApi,
  decUserSendSmsApi,
  updateProductUserApi,
} from "@/api/declare.js";
import { mapGetters, mapActions } from "vuex";
// import { Verification, userRegister } from "@/api/login.js";
import md5 from "js-md5";
export default {
  name: "Register",
  data() {
    return {
      dataInfo: {
        userName: "",
        passWord: "",
        rePassWord: "",
        chargeName: "" /* 单位负责人姓名 */,
        chargeMobile: "" /* 单位联系人姓名 */,
        contactName: "" /* 单位联系人姓名 */,
        contactMobile: "" /* 单位联系人手机 */,
        selsecinfo: undefined /* 申报入口 */,
        email: "",
        phone: "",
        bankAccount: "" /* 银行账户 */,
        bankAddress: "" /* 开户行 */,
        bankName: "" /* 户名 */,
        verificationCode: "" /* 验证码 */,
        position: "" /* 职务 */,
      },
      declareList: [
        {
          likeName: "123",
          id: 1,
        },
      ] /* 申报入口列表 */,
      mobile: "", //手机号
      likeName: "", //昵称
      VerificationCode: "", //验证码
      email: "", //邮箱
      password: "", //密码
      passwords: "", //密码
      codeKey: "", //验证码串
      buttonName: "发送验证码", //发送验证码
      isDisabled: false,
      second: 60,
    };
  },
  methods: {
    //配置令牌
    ...mapActions(["setToken"]),
    registerClick(val) {
      this.$emit("backLogin", val);
    },
    handleChange() {},
    login() {
      this.$emit("goLogin", 0);
    },

    register() {
      if (this.dataInfo.userName == "") {
        this.$message.warn("请输入单位名称");
        return;
      }
      if (this.dataInfo.position == "") {
        this.$message.warn("请输入职务");
        return;
      }

      if (this.dataInfo.phone == "") {
        this.$message.warn("请输入联系电话");
        return;
      }
      if (this.dataInfo.email == "") {
        this.$message.warn("请输入邮箱");
        return;
      }
      if (this.dataInfo.bankAddress == "") {
        this.$message.warn("请输入开户行");
        return;
      }
      if (this.dataInfo.bankName == "") {
        this.$message.warn("请输入户名");
        return;
      }
      if (this.dataInfo.bankAccount == "") {
        this.$message.warn("请输入银行账户");
        return;
      }
      this.setToken(sessionStorage.getItem("token"));
      let params = {
        // Authorization: sessionStorage.getItem("token"),
        productUserId: JSON.parse(localStorage.getItem("userModel"))
          .productUserId,
        id: JSON.parse(localStorage.getItem("userModel")).id,
        unitName: this.dataInfo.userName,
        job: this.dataInfo.position,
        email: this.dataInfo.email,
        bankName: this.dataInfo.bankAddress,
        bankUser: this.dataInfo.bankName,
        bankAccount: this.dataInfo.bankAccount,
        userName: JSON.parse(localStorage.getItem("userModel")).userName,
        userPhone: this.dataInfo.phone,
      };
      updateProductUserApi(params).then((res) => {
        if (res.status) {
          this.$message.success("修改成功，请重新登录");
          setTimeout(() => {
            this.$emit("goLogin");
          }, 500);
        } else {
          if(res.errors) {
            this.$message.error(res.errors.message || "服务器发生错误");
            return
          }
          this.$message.error(res.message || "服务器发生错误");
        }
      });
    },
    //忘记密码
    secret() {
      this.$emit("forget");
    },
  },
  created(){
    
  }
};
</script>
<style scoped lang="scss">
@import "./index.scss";
</style>
